export default __webpack_public_path__ + "static/media/bill.284688e6.gif";